// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/adverse-winds-and-gusts.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/adverse-winds-and-gusts/adverse-winds-and-gusts.js';

mount([g0]);
